export default "__VITE_ASSET__D2D_J7y0__"